<button [ngClass]="'cb-button-'+type" [class.disabled]="disabled" [class.full-width]="fullWidth"
  (click)="click($event)" [class.table-button]="tableButton">
  <div class="cb-button-content">
    <cb-icon *ngIf="icon && iconPos=='left'" [name]="icon"></cb-icon>
    <ng-content></ng-content>
    <cb-icon *ngIf="icon && iconPos=='right'" [name]="icon"></cb-icon>
  </div>
</button>
